import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import qs from 'query-string';

import { BetManager, BettorApi, constants } from '@atlas/core';

const usePublicBet = setSelectedBetTypeIndex => {
  const location = useLocation();
  const { search } = location;

  useEffect(() => {
    const { bet: betId } = qs.parse(search);

    if (!betId || !Number.isFinite(Number(betId))) {
      return;
    }

    BettorApi.getPublicBetById(betId).then(bet => {
      const { outcomes } = bet;

      outcomes.forEach(outcome => {
        BetManager.addBet({
          betGroups: outcome.outcomeInfo.betMarketGroups,
          betType: bet.betType,
          eventId: outcome.outcomeInfo.eventId,
          marketId: outcome.outcomeInfo.marketId,
          marketTypeId: outcome.outcomeInfo.marketTypeId,
          outcomeId: outcome.outcomeId,
        });
      });

      if (bet.betType === constants.BET_TYPE.SYSTEM && bet.winCombinationSize) {
        setSelectedBetTypeIndex(bet.winCombinationSize - 1);
      }
    });
  }, [search, setSelectedBetTypeIndex]);
};

usePublicBet.propTypes = {
  setSelectedBetTypeIndex: PropTypes.func,
};

export default usePublicBet;
